/**
 * App — the router. Wires the pages into the URL structure.
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { HomePage } from './pages/HomePage';
import { ModulesPage } from './pages/ModulesPage';
import { ModuleDetailPage } from './pages/ModuleDetailPage';
import { BundlesPage } from './pages/BundlesPage';
import { BundleDetailPage } from './pages/BundleDetailPage';
import { VariantsPage } from './pages/VariantsPage';
import { DocsPage } from './pages/DocsPage';
import PactViewerPage from './pages/PactViewerPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/modules" element={<ModulesPage />} />
          <Route path="/modules/:id" element={<ModuleDetailPage />} />
          <Route path="/bundles" element={<BundlesPage />} />
          <Route path="/bundles/:id" element={<BundleDetailPage />} />
          <Route path="/variants" element={<VariantsPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/docs/fvw" element={<DocsPage />} />
          <Route path="/docs/fvw/:section" element={<DocsPage />} />
          <Route path="/docs/pact" element={<DocsPage />} />
          <Route path="/docs/pact/:doc" element={<DocsPage />} />
          <Route path="/pact-viewer" element={<PactViewerPage />} />
          <Route path="/pact-viewer/:id" element={<PactViewerPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
// last trigger
